// material-ui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function Footer() {
  return (
    <Stack
      direction="row"
      sx={{ alignItems: 'center', justifyContent: 'flex-start', p: '24px 16px 0px', mt: 'auto' }}
    >
      <Typography variant="caption">
        COPYRIGHT &copy; 2026 ALL RIGHTS RESERVED
      </Typography>
    </Stack>
  );
}
